module.exports = __webpack_public_path__ + "static/media/il.46e20905.svg";